module.exports = __webpack_public_path__ + "img/community.8ffcac04.svg";